import { Component } from "@angular/core";
import { XOArrayField } from './xo-array-field.component';

@Component({
    selector: "xo-field-array-time",
    templateUrl: "./xo-field-array-time.component.html"
})
export class XOArrayFieldTime extends XOArrayField {
}
